import * as z from "zod";

export const accountAddSchema = z.object({
    username: z
    .string()
    .min(4, "아이디는 최소 4자 이상이어야 합니다.")
    .max(20, "아이디는 최대 20자까지 가능합니다.")
    .regex(/^[a-zA-Z][a-zA-Z0-9]*$/, "아이디는 영어 및 숫자만 가능하며 숫자로 시작할 수 없습니다."),
    password: z
    .string()
    .optional(),
    confirmPassword: z
    .string()
    .optional(),
    email: z
    .string()
    .email("유효한 주소를 입력해주세요."),
    authCode: z
    .string()
    .regex(/^\d{6}$/, "인증 코드는 6자리 숫자여야 합니다.")
    .optional(),
    isSuperUser: z
    .boolean()
    .optional()
    .default(false),
}).superRefine((data, ctx) => {
    // 회원가입 비밀번호 검증
    if (!data.password || data.password.length < 8) {
        ctx.addIssue({
            path: ["password"],
            code: z.ZodIssueCode.custom,
            message: "비밀번호는 최소 8자 이상이어야 합니다.",
        });
    }

    if (data.password !== data.confirmPassword) {
        ctx.addIssue({
            path: ["confirmPassword"],
            code: z.ZodIssueCode.custom,
            message: "비밀번호가 일치하지 않습니다.",
        });
    }
});

// 🔹 타입 정의
export type AccountAddFormValues = z.infer<typeof accountAddSchema>;